import type { EventName, EventPropertiesDeprecated } from 'lib/segment';
import type { MergeRequestData, Login } from 'features/auth';

export const onApproveReject = (
  approved: boolean,
  mergeRequestId: string | null,
  mergeRequest: MergeRequestData,
  event: (eventName: EventName, properties: EventPropertiesDeprecated) => void,
  userData?: Login,
  selectedOrganizations?: Record<string, string[]>
) => {
  try {
    event(approved ? 'Supplier Merge Request Approved' : 'Supplier Merge Request Rejected', {
      objectType: 'Form',
      action: 'Update',
      targetType: 'Merge Request',
      targetId: mergeRequestId,
      targetName: 'Legacy Supplier Merge',
      page: 'Merge Request Details',
      businessContext: approved
        ? {
            approvedByUserId: userData?.loginContext?.id,
            userMappingsCount: mergeRequest?.data.legacyUsers?.length,
            legacyOrgId: mergeRequest?.data.legacyOrganization.id,
            designerOrgId: mergeRequest?.data.designerOrganization.id,
          }
        : { rejectedByUserId: userData?.loginContext?.id },
    });
    mergeRequest?.data?.legacyUsers.forEach(user => {
      if (!user.userMergeScenario && !user.alreadyInPortal) {
        event('Supplier Portal User Created', {
          objectType: 'User Account',
          action: 'Create',
          targetType: 'Supplier User',
          targetId: user.legacyUserId,
          targetName: user.name,
          source: 'System',
          page: 'Various',
          businessContext: {
            email: user.email,
            role: user.type,
            organizationId: mergeRequest?.data?.supplierPortalOrganization.id,
          },
        });
      }
      if (
        (user.type === 'supplier_user' || user.type === 'supplier_admin') &&
        !user.alreadyInPortal
      ) {
        event('Supplier User Migrated', {
          objectType: 'User Account',
          action: 'Create',
          targetType: 'Supplier User',
          targetId: user.legacyUserId,
          targetName: user.name,
          source: 'System',
          page: 'Merge Process',
          businessContext: {
            email: user.email,
            role: user.type,
            designerOrganizationIds: selectedOrganizations?.[user.legacyUserId]
              ?.map(org => parseInt(org))
              .join(','),
            accessToAllBrands: selectedOrganizations?.[user.legacyUserId]?.some(
              org => org === '-1'
            ),
          },
        });
      }
    });
  } catch (error) {
    return;
  }
};
